import {Layout, Drawer, Button} from "antd";
import {useState} from "react";
import {ToggleButton, Logo, NavMenu} from "./index";
import cn from "classnames/bind";
import {Close} from "@/theme/layout/main/sidebar/icons";


const width = {
    collapsedWidth: 80,
    width: 256,
}
export const Sidebar = ({}) => {

    return (
        <>
            <div className={'MobileMenu'}>
                <MobileMenu />
            </div>
            <div className={'DesktopMenu'}>
                <DesktopMenu />
            </div>
        </>
    );
}

const MobileMenu = () =>{
    const [collapsed, setCollapsed] = useState(false);

    return (
        <>
            <div className={cn('mobile_menu_trigger_wrapper')}>
                <Button
                    type="text"
                    icon={<Close />}
                    onClick={() => setCollapsed(!collapsed)}
                />
            </div>

            <Drawer
                className={'sidebar_menu_wrapper mobile'}
                placement="left"
                onClose={()=>setCollapsed(!collapsed)}
                open={collapsed}
                closeIcon={false}
                width={208}
                styles={{
                    body: {
                        padding: 0,
                    }
                }}
            >
                <Logo
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                />

                <NavMenu
                    collapsed={collapsed}
                    setCollapsed={()=>{
                        setCollapsed(!!!collapsed)
                    }}
                />

                <ToggleButton
                    mobile
                />
            </Drawer>
        </>
    )
}

const DesktopMenu = () =>{
    const [collapsedHover, setCollapsedHover] = useState(true);
    const [collapsed, setCollapsed] = useState(true);

    return(
        <Layout.Sider
            collapsible
            collapsed={collapsed}
            trigger={null}
            width={width.width}
            collapsedWidth={width.collapsedWidth}
            onMouseEnter={()=>{
                if (collapsed){
                    setCollapsedHover(false)
                }

            }}
            onMouseLeave={()=>{
                if (collapsed){
                    setCollapsedHover(true)
                }
            }}
        >
            <div className={'sidebar'}>
                <div
                    style={{
                        position: collapsed ? "absolute" : 'relative',
                        height: '100%',
                        width: !collapsedHover ? width.width : width.collapsedWidth
                    }}
                >
                    <Layout.Sider
                        className={'sidebar_menu_wrapper'}
                        collapsible
                        collapsed={collapsedHover}

                        trigger={null}
                        width={width.width}
                        collapsedWidth={width.collapsedWidth}
                    >
                        <Logo
                            collapsed={collapsed && collapsedHover}
                        />

                        <NavMenu
                            collapsed={collapsed}
                        />
                    </Layout.Sider>

                    <ToggleButton
                        collapsed={collapsed}
                        collapsedHover={collapsedHover}
                        setCollapsed={setCollapsed}
                    />
                </div>
            </div>
        </Layout.Sider>
    )
}